<template>
    <div class="modal fade" id="confirmSingleDeleteProduct" tabindex="-1" role="dialog" aria-labelledby="confirmSingleDeleteProduct" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">{{delHeaderMsg ? delHeaderMsg : 'Delete Product'}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click = "closePopUpAction">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>{{ isDiffMsg ? isDiffMsg : ( notDeleted ? 'Cannot Delete The Product' : 'Are you sure, you want to delete?')}}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" @click = "closePopUpAction">No</button>
                    <button type="button" @click="deleteSelectedProducts" class="btn btn-primary" data-dismiss="modal">Yes</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'DeleteSingleProductConfirmModal',
    data() {
        return {

        }
    },
    props: {
		isDiffMsg:String,
		notDeleted : Boolean,
		delHeaderMsg: String
    },
    methods: {
        deleteSelectedProducts() {
			if(this.notDeleted){
				$('#confirmSingleDeleteProduct').modal('hide')
			}else{
				this.$emit('deleteSelectedProducts')

			}
        },
		closePopUpAction(){
            this.$emit("closeActiveRuleModal")
            this.$emit("hideAction")
		}
    },
}
</script>

<style lang="scss">

</style>
